import ArrowConfiguration from './ArrowConfiguration';
import CircleConfiguration from './CircleConfiguration';
import EllipseConfiguration from './EllipseConfiguration';
import HalfCircleConfiguration from './HalfCircleConfiguration';
import HeartConfiguration from './HeartConfiguration';
import HexagonConfiguration from './HexagonConfiguration';
import IsoscelesTriangleConfiguration from './IsoscelesTriangleConfiguration';
import NullConfiguration from './NullConfiguration';
import QuarterCircleConfiguration from './QuarterCircleConfiguration';
import RectangleConfiguration from './RectangleConfiguration';
import RightAngledTriangleConfiguration from './RightAngledTriangleConfiguration';
import RoundedRectangleConfiguration from './RoundedRectangleConfiguration';
import SlopedRectangleConfiguration from './SlopedRectangleConfiguration';
import ArchedRectangleConfiguration from './ArchedRectangleConfiguration';
import StarConfiguration from './StarConfiguration';
import TextConfiguration from './TextConfiguration';
import TrapezoidConfiguration from './TrapezoidConfiguration';
import { ShapeConfigurationInterface } from './ShapeConfigurationInterface';
import FlatOvalConfiguration from './FlatOvalConfiguration';
import SlopedRightRectangleConfiguration from './SlopedRightRectangleConfiguration';
import OctagonConfiguration from './OctagonConfiguration';
import DropletConfiguration from './DropletConfiguration';
import PolygonConfiguration from './PolygonConfiguration';
import EggConfiguration from './EggConfiguration';
import KiteConfiguration from './KiteConfiguration';
import BarrelConfiguration from './BarrelConfiguration';
import JewelConfiguration from './JewelConfiguration';
import ParallogramConfiguration from './ParallelogramConfiguration';

export default class ShapeConfigurationFactory {
	get_configuration( shape ): ShapeConfigurationInterface {
		switch( shape ) {
			case 'arrow':
				return new ArrowConfiguration();
			case 'circle':
				return new CircleConfiguration();
			case 'egg':
				return new EggConfiguration();
			case 'ellipse':
				return new EllipseConfiguration();
			case 'flat-oval':
				return new FlatOvalConfiguration();
			case 'half-circle':
				return new HalfCircleConfiguration();
			case 'heart':
				return new HeartConfiguration();
			case 'hexagon':
				return new HexagonConfiguration();
			case 'octagon':
				return new OctagonConfiguration();
			case 'polygon':
				return new PolygonConfiguration();
			case 'isosceles-triangle':
				return new IsoscelesTriangleConfiguration();
			case 'quarter-circle':
				return new QuarterCircleConfiguration();
			case 'rectangle':
				return new RectangleConfiguration();
			case 'right-angled-triangle':
			case 'right-angled-triangle-mirrored':
				return new RightAngledTriangleConfiguration();
			case 'rounded-rectangle':
				return new RoundedRectangleConfiguration();
			case 'sloped-rectangle':
			case 'sloped-rectangle-flip-horizontal':
				return new SlopedRectangleConfiguration();
			case 'sloped-right-rectangle':
			case 'sloped-right-rectangle-flip-vertical':
				return new SlopedRightRectangleConfiguration();
			case 'arched-rectangle':
				return new ArchedRectangleConfiguration();
			case 'star':
				return new StarConfiguration();
			case 'text':
				return new TextConfiguration();
			case 'trapezoid':
				return new TrapezoidConfiguration();
			case 'kite':
				return new KiteConfiguration();
			case 'barrel':
				return new BarrelConfiguration();
			case 'jewel':
				return new JewelConfiguration();
			case 'droplet':
				return new DropletConfiguration();
			case 'parallelogram-flip-horizontal':
			case 'parallelogram':
				return new ParallogramConfiguration();
			default:
				return new NullConfiguration();
		}
	}
}
